import { ApplovinClientUserData, ApplovinEventName } from "../../Common/models/applovin";
import { doPost, getRequestHeaders } from "../../Common/utils/https";
import { cloudFunctionsUrl } from "../firebase";

const baseUrl = cloudFunctionsUrl;

export const applovinTrackEvent = async (data: {
  name: ApplovinEventName;
  dedupe_id?: string;
  event_source_url: string;
  data: Record<string, unknown>;
  user: ApplovinClientUserData;
}) => {
  const url = `${baseUrl}applovinTrack/track`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, data);
};
